import { ensureStartSlash } from '@apparel/core/utils/strings/ensureSlash';
import { useCallback, useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FakeLink } from './FakeLink';

export const useNavigation = () => {
    const history = useHistory();
    const basename = useMemo(() => history?.createHref({ pathname: '' }), [history]);

    const cleanPathUrl = useCallback(
        (link: string) => (basename ? ensureStartSlash(link.replace(basename, '')) : link),
        [basename],
    );

    return {
        cleanPathUrl,
        history,
        basename,

        LinkComponent: history ? Link : FakeLink,
    };
};
